module.exports = {"140724100":"乐平镇","140724101":"皋落镇","140724102":"冶头镇","140724103":"沾尚镇","140724104":"大寨镇","140724200":"李家庄乡","140724201":"界都乡","140724202":"三都乡","140724203":"赵壁乡","140724204":"孔氏乡","140724205":"闫庄乡","140724206":"西寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140724.json
// module id = 285
// module chunks = 0